module.exports = __webpack_public_path__ + "assets/img/0617.61036906.svg";